// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Stock_ReturnItemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/stock/return_item
 *
 * Process a customer return, incrementing stock.
 */
import { registerContract } from './validate'

export interface Stock_ReturnItemInput {
product_id: number
quantity: number
order_item_id?: number
notes?: string
}

registerContract('Stock_ReturnItemInput', {
  product_id:    { type: 'number',  required: true },
  quantity:      { type: 'number',  required: true },
  order_item_id: { type: 'number',  required: false },
  notes:         { type: 'string',  required: false },
})
